import {
  getAuctionIndicators,
  getBatchIndicators,
  getReceiptIndicators
} from '@/febos/servicios/api/busqueda.api';

export const getAuctionsIndicators = async ({ commit }, params) => {
  try {
    commit('SET_LOADING', true);
    const response = await getAuctionIndicators(params);
    commit('SET_GENERAL_AUCTION_INDICATORS', response.data.datos);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const getBatchesIndicators = async ({ commit }, params) => {
  try {
    commit('SET_LOADING', true);
    const response = await getBatchIndicators(params);
    commit('SET_GENERAL_BATCH_INDICATORS', response.data.datos);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const getReceiptsIndicators = async ({ commit }, params) => {
  try {
    commit('SET_LOADING', true);
    const response = await getReceiptIndicators(params);
    commit('SET_GENERAL_RECEIPTS_INDICATORS', response.data.datos);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};
